<template>
	<div class="header prelative ofhidden bg-main">
		<div class="header-bg bg-main pabsolute trans"></div>
		<div class="htmldiv pt5 pb5 ofhidden dflex prelative">
			<a :href="$params.baseDir">
				<img src="@/assets/images/jm_logo_t.png" alt="" class="logo dblock">
			</a>
			<div v-if="showInput" class="index-search-input search-input bg-main br5 ofhidden prelative">
				<span class="iconfont icon-sousuo pabsolute"></span>
				<input v-model.trim="searchInput" class="input trans3" placeholder="请输入关键字搜索" type="text" name="" maxlength="">
				<div @click="_searchInput" class="search-btn pabsolute cpointer tcenter">
					搜索
				</div>
			</div>
		</div>
	</div>
</template>
<script>
export default {
    name: "Top",
    data: function () {
        return {
            searchInput: '',
            showInput: true,
            //showInput: true
        }
    },
    watch: {
        $route: {
            handler(val, oldval) {
                this.controlInput()
            },
            deep: true,// 深度观察监听
            immediate: true
        }
    },
    methods: {
        _searchInput(){

            this.$router.push({
                path: '/search?sInput=' + this.searchInput
            })
        },
        controlInput(){
            if (this.$route.path == '/search') //是否显示导航的搜索框
                this.showInput = false
            else
                this.showInput = true

        }
    }
}
</script>
<style scope>
	.pheader:hover .header{
		transform: scale(1.1);
	}
</style>
